var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('reactive-base',{attrs:{"app":"witness_person","credentials":_vm.user.user.es_username + ':' + _vm.user.user.es_password,"url":_vm.elasticUrl}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header statistics-filter"},[_c('div',{staticClass:"widget-header-label"},[_c('h3',[_vm._v(_vm._s(_vm.$t('labels.selected-filters')))])]),_c('div',{staticClass:"widget-header-toolbar"},[_c('div',{staticClass:"actions"},[_c('SelectedFilters',{staticClass:"bb-1 curent-filters pl-4 m-0",attrs:{"clearAllLabel":this.$t('labels.clear')}})],1)])])])]),_c('v-guard',{attrs:{"permissions":['court-page-statistics-use-filter']}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header statistics-filter"},[_c('multi-list',{attrs:{"componentId":"yearFilter","filterLabel":this.$t('labels.year'),"title":this.$t('labels.year'),"dataField":"year.raw","className":"horizontal-filter year-filter","sortBy":"asc","showSearch":false,"URLParams":true,"react":{ and: _vm.getOtherFilterIds('yearFilter') }},on:{"valueChange":_vm.setSelectedYears},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
return [_c('div',[_vm._v(_vm._s(label))])]}}])}),_c('multi-list',{attrs:{"componentId":"quarterFilter","filterLabel":this.$t('labels.quarter'),"title":this.$t('labels.quarter'),"dataField":"quarter.raw","className":"horizontal-filter quarter-filter","sortBy":"asc","showSearch":false,"URLParams":true,"react":{ and: _vm.getOtherFilterIds('quarterFilter') }},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
return [_c('div',[_vm._v(" "+_vm._s(label)+" ")])]}}])}),_c('multi-list',{attrs:{"componentId":"monthFilter","filterLabel":this.$t('labels.month'),"title":this.$t('labels.month'),"dataField":"month.raw","className":"horizontal-filter month-filter","sortBy":"asc","size":12,"showSearch":false,"URLParams":true,"transformData":_vm.sortMonthByLabel,"react":{ and: _vm.getOtherFilterIds('monthFilter') }},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
var count = ref.count;
return [_c('div',[_vm._v(" "+_vm._s(_vm.renameMonthsLabel(label))+" ")])]}}])})],1)])]),_c('div',{staticClass:"col-lg-12 col-xl-3 order-lg-1 order-xl-1"},[_c('div',{staticClass:"widget widget-facets statistics-vertical"},[_c('div',{staticClass:"widget-header mb-3"},[_c('div',{staticClass:"widget-header-label"},[_c('h3',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"fas fa-circle-notch fa-spin"}),_vm._v(_vm._s(_vm.$t('labels.filtration')))])]),_c('div',{staticClass:"widget-header-toolbar"},[_c('div',{staticClass:"actions"})])]),_c('reactive-component',{attrs:{"componentId":"ticketStatusFilter","URLParams":false,"react":{ and: _vm.getOtherFilterIds('ticketStatusFilter') },"customQuery":_vm.defaultQuery}}),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"genderFilter","filterLabel":this.$t('labels.gender'),"title":this.$t('labels.gender'),"dataField":'gender.raw',"react":{ and: _vm.getOtherFilterIds('genderFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"agesFilter","filterLabel":this.$t('labels.age-group'),"title":this.$t('labels.age-group'),"dataField":'age.raw',"transformData":_vm.customSortAge,"react":{ and: _vm.getOtherFilterIds('agesFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"testimonyApplicantFilter","filterLabel":"Typ av stödsökande","title":"Typ av stödsökande","dataField":'testimony_applicant.raw',"react":{ and: _vm.getOtherFilterIds('testimonyApplicantFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":"Typ av mål","componentId":"testimonyTypeSubFilter","filterLabel":"Typ av mål","dataField":'testimony_type.raw',"react":{ and: _vm.getOtherFilterIds('testimonyTypeSubFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"crimesFilter","size":300,"title":this.$t('labels.crime'),"filterLabel":this.$t('labels.crime'),"dataField":this.$field('crime')+'.raw',"react":{ and: _vm.getOtherFilterIds('crimesFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"civilCaseFilter","title":"Civilmålstyp","filterLabel":"Civilmålstyp","dataField":'testimony_other_type.raw',"react":{ and: _vm.getOtherFilterIds('civilCaseFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":"Externt mål","componentId":"externalCaseFilter","filterLabel":"Externt mål","dataField":'external_case.raw',"react":{ and: _vm.getOtherFilterIds('externalCaseFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":"Säkerhetssal","componentId":"testimonySecurityRoomFilter","filterLabel":"Säkerhetssal","dataField":'testimony_security_room.raw',"react":{ and: _vm.getOtherFilterIds('testimonySecurityRoomFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.special-circumstances'),"componentId":"specialCircumstanceFilter","filterLabel":this.$t('labels.special-circumstances'),"nestedField":"crime_relation","dataField":'crime_relation.label.raw',"react":{ and: _vm.getOtherFilterIds('specialCircumstanceFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.special-events'),"componentId":"specialEventFilter","filterLabel":this.$t('labels.special-events'),"dataField":'special_event.raw',"react":{ and: _vm.getOtherFilterIds('specialEventFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"}),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":100,"componentId":"officeFilter","title":this.$t('labels.victim-support-centre'),"filterLabel":this.$t('labels.victim-support-centre'),"dataField":"office.raw","react":{ and: _vm.getOtherFilterIds('officeFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"courtFilter","filterLabel":"Domstol","title":"Domstol","dataField":"court.raw","size":1000,"react":{ and: _vm.getOtherFilterIds('courtFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"userSubFilter","title":this.$t('labels.administrator'),"dataField":"user.raw","size":1000,"react":{ and: _vm.getOtherFilterIds('userSubFilter') }}})],1)],1)])]),_c('div',{staticClass:"col-lg-12 col-xl-9 order-lg-1 order-xl-1"},[_c('reactive-component',{attrs:{"componentId":"myColorPicker","URLParams":true,"react":{ and: _vm.getOtherFilterIds('') },"defaultQuery":function () { return ({
                query: this$1.defaultQuery(),
                runtime_mappings: {
                    'date.month_of_years': {
                      type: 'long',
                      script: 'emit(doc[\'created_at\'].value.getMonthValue())'
                    }
                  },
                  aggs: {
                    year: {
                      terms: {
                          field: 'year.raw',
                          order: {
                              _key: 'asc'
                          },
                          min_doc_count: 0,
                          size: 100
                      }
                    },
                    crimes: {
                      terms: {
                        field: 'crime.raw',
                        order: {
                          _key: 'asc'
                        },
                        size: 100
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    office: {
                      terms: {
                        field: 'office.raw',
                        order: {
                          _key: 'asc'
                        },
                        size: 100
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    testimony_security_room: {
                      terms: {
                        field: 'testimony_security_room.raw',
                        order: {
                          _key: 'asc'
                        }
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    court_contact_type: {
                      terms: {
                        field: 'court_contact_type.raw',
                        order: {
                          _key: 'asc'
                        }
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    gender: {
                      terms: {
                        field: 'gender.raw',
                        order: {
                          _key: 'asc'
                        }
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    age: {
                      terms: {
                        field: 'age.raw',
                        order: {
                          _key: 'asc'
                        }
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    testimony_applicant: {
                      terms: {
                        field: 'testimony_applicant.raw',
                        order: {
                          _key: 'asc'
                        }
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    month: {
                      terms: {
                        field: 'date.month_of_years',
                        order: {
                          _key: 'asc'
                        },
                        size: 100
                      },
                      aggs: {
                        year: {
                          terms: {
                            script: 'if (doc[\'created_at\'].size() != 0) doc[\'created_at\'].value.getYear()',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    quarter: {
                      terms: {
                        field: 'quarter.raw',
                        order: {
                          _key: 'asc'
                        }
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    user: {
                      terms: {
                        field: 'user.raw',
                        order: {
                          _key: 'asc'
                        },
                        size: 1000,
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 1000
                          }
                        }
                      }
                    },
                    testimony_support: {
                      nested: {
                        path: 'testimony_support'
                      },
                      aggs: {
                        relation: {
                          terms: {
                            field: 'testimony_support.label.raw',
                            order: {
                              _key: 'asc'
                            },
                            size: 100
                          },
                          aggs: {
                            reverted: {
                              reverse_nested: {},
                              aggs: {
                                year: {
                                  terms: {
                                    field: 'year.raw',
                                    order: {
                                      _key: 'asc'
                                    },
                                    min_doc_count: 0,
                                    size: 100
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    },
                    persons: {
                      nested: {
                        path: 'persons'
                      },
                          aggs: {
                            reverted: {
                              reverse_nested: {},
                              aggs: {
                                year: {
                                  terms: {
                                    field: 'year.raw',
                                    order: {
                                      _key: 'asc'
                                    },
                                    min_doc_count: 0,
                                    size: 100
                                  }
                                }
                              }
                        }
                      }
                    },
                    external_case: {
                      terms: {
                        field: 'external_case.raw',
                        order: {
                          _key: 'asc'
                        }
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    court: {
                      terms: {
                        field: 'court.raw',
                        order: {
                          _key: 'asc'
                        },
                        size: 100
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    testimony_other_type: {
                      terms: {
                        field: 'testimony_other_type.raw',
                        order: {
                          _key: 'asc'
                        }
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 1000000
                          }
                        }
                      }
                    },
                    testimony_type: {
                      terms: {
                        field: 'testimony_type.raw',
                        order: {
                          _key: 'asc'
                        }
                      },
                      aggs: {
                        year: {
                          terms: {
                            field: 'year.raw',
                            order: {
                              _key: 'asc'
                            },
                            min_doc_count: 0,
                            size: 100
                          }
                        }
                      }
                    },
                    crime_relation: {
                        nested: {
                            path: 'crime_relation',
                        },
                        aggs: {
                            relation: {
                                terms: {
                                    field: 'crime_relation.label.raw',
                                    order: {
                                        _key: 'asc'
                                    },
                                    size: 100,
                                },
                                aggs: {
                                    reverted: {
                                        reverse_nested: {},
                                        aggs: {
                                            year: {
                                                terms: {
                                                    field: 'year.raw',
                                                    order: {
                                                        _key: 'asc'
                                                    },
                                                    min_doc_count: 0,
                                                    size: 100,
                                                }
                                            }
                                        }
                                    }
                                },
                            },
                        },
                    },
                    special_event: {
											terms: {
												field:  this$1.$field('special_event')+'.raw',
												order: {
													_key: 'asc'
												},
                        size: 100,
											},
											aggs: {
												year: {
													terms: {
														field: 'year.raw',
														order: {
															_key: 'asc'
														},
														min_doc_count: 0,
														size: 100,
													},
												},
											},
										},
                  }
              }); }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
              var aggregations = ref.aggregations;
              var hits = ref.hits;
              var setQuery = ref.setQuery;
return _c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('statistic-widget-total',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.year.buckets,"title":_vm.$t('labels.total')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.quarter.buckets,"infoBox":'',"title":_vm.$t('labels.quarter')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.month.buckets,"infoBox":'',"title":_vm.$t('labels.month')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.gender.buckets,"infoBox":'',"title":_vm.$t('labels.gender')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":_vm.customSortAge(aggregations.age.buckets),"infoBox":'',"title":_vm.$t('labels.age-group')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.testimony_applicant.buckets,"infoBox":'',"title":"Typ av stödsökande"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.testimony_type.buckets,"infoBox":'',"title":"Typ av mål"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.crimes.buckets,"infoBox":'',"title":_vm.$t('labels.crime')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.testimony_other_type.buckets,"infoBox":'',"title":"Civilmålstyp"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.external_case.buckets,"infoBox":'',"title":"Externt mål"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.testimony_security_room.buckets,"infoBox":'',"title":"Säkerhetssal"}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.crime_relation.relation.buckets,"title":_vm.$t('labels.special-circumstances')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.special_event.buckets,"title":_vm.$t('labels.special-events')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.office.buckets,"infoBox":'',"title":_vm.$t('labels.victim-support-centre')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.court.buckets,"infoBox":'',"title":"Domstol"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.user.buckets,"infoBox":'',"title":_vm.$t('labels.administrator')}})],1)])])}}])})],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }